import { getManagedCredential } from "../auth-refresh-coordinator"
import { BACKEND_URI, fetchWithAuthRetry, getHeaders } from "./_shared"

export type M365ConnectionStatus = {
  status:
    | "connected"
    | "reconnect_required"
    | "revoked"
    | "insufficient_scopes"
    | "not_connected"
    | "error"
  scopes?: string[]
  cleanup_pending?: boolean
  entra_revocation_required?: boolean
}
const url = `${BACKEND_URI}/m365/connection`
export async function getM365Connection(): Promise<M365ConnectionStatus> {
  return (await fetchWithAuthRetry(url, { headers: getHeaders(getManagedCredential()) })).json()
}
export async function authorizeM365Connection(
  redirectUri: string
): Promise<{ auth_url: string; state: string }> {
  return (
    await fetchWithAuthRetry(`${url}/authorize`, {
      method: "POST",
      headers: getHeaders(getManagedCredential()),
      body: JSON.stringify({ redirect_uri: redirectUri }),
    })
  ).json()
}
export async function completeM365Connection(query: string): Promise<M365ConnectionStatus> {
  return (
    await fetchWithAuthRetry(`${url}/callback?${query}`, {
      headers: getHeaders(getManagedCredential()),
    })
  ).json()
}
export async function disconnectM365Connection(): Promise<M365ConnectionStatus> {
  return (
    await fetchWithAuthRetry(url, { method: "DELETE", headers: getHeaders(getManagedCredential()) })
  ).json()
}
